export class CurationEvidence {
  tier: string;
  diagnosticMaxEvidLevel: string;
  prognosticMaxEvidLevel: string;
  therapeuticMaxEvidLevel: string;
}

export class CurationEvidenceBuilder {
  private _evidence: CurationEvidence;

  constructor() {
    this._evidence = <CurationEvidence> { };
  }

  public  setDiagnosticMaxEvidLevel(diagnosticMaxEvidLevel: string): CurationEvidenceBuilder {
    this._evidence.diagnosticMaxEvidLevel = this.isBenign(diagnosticMaxEvidLevel);
    return this;
  }

  public  setprognosticMaxEvidLevel(prognosticMaxEvidLevel: string): CurationEvidenceBuilder {
    this._evidence.prognosticMaxEvidLevel = this.isBenign(prognosticMaxEvidLevel);
    return this;
  }

  public  setTherapeuticMaxEvidLevel(therapeuticMaxEvidLevel: string): CurationEvidenceBuilder {
    this._evidence.therapeuticMaxEvidLevel = this.isBenign(therapeuticMaxEvidLevel);
    return this;
  }

  public  setTier(tier: string): CurationEvidenceBuilder {
    this._evidence.tier = tier;
    return this;
  }

  public  getEvidence(): CurationEvidence {
    return this._evidence;
  }


  private isBenign(level: string): string {
   if (level != null && level.toUpperCase() === 'Benign'.toUpperCase()) {
     return 'V';
   }
   return level;
  }
}
